import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import PermissionsHead from "./PermissionsParts/PermissionsHead";
import trans from "../../../utils";
import Actions from "../../antd/Table/Actions";
import AntdTable from "../../antd/Table/Table";
import PermissionsForm from "./PermissionsForms/PermissionsForms";
import { useGetAllPermissionsQuery } from "../../../Redux/service/Roles&Permissions/RolesPermissions";
import { filtrationcontext } from "../../../context/Filtercontext";
import { popupcontext } from "../../../context/Popupscontext";
import { formatDateString } from "../../../JsHelpers/DateFormat";
import usePermission from "../../../hooks/usePermission";
import { Tag } from "antd";

export default function Permissions() {
	const { deleteItem, setDeleteItem, setReloadData, reloadData } =
		useContext(popupcontext);
	const { create, edit, delete: canDelete } = usePermission("SETUPUSERROLES");

	const [currentPage, setCurrentPage] = useState(1);
	const [sort, setSort] = useState({
		by: "",
		order: "",
	});
	const buildQueryString = (filterObj) => {
		const query = Object.entries(filterObj)
			.filter(
				([_, value]) => value !== null && value !== "" && value !== undefined
			)
			.map(([key, value]) => `${key}=${value}`)
			.join("&");

		return query ? `${query}` : "";
	};
	const [filter, setFilter] = useState({
		modules: null,
		resources: null,
		actions: null,
	});

	const queryString = buildQueryString(filter);
	const {
		limit,
		setLimit,
		setSort: SetSortFilter,
		searchQuery,
		setSearchQuery,
	} = useContext(filtrationcontext);
	const { data: PermissionsData, refetch } = useGetAllPermissionsQuery(
		{
			page: currentPage,
			limit: limit,
			search: searchQuery,
			sortby: sort.by,
			order: sort.order,
			queryString: queryString,
		},
		{
			skip: !currentPage || !limit,
		}
	);
	useEffect(() => {
		localStorage.setItem("page", currentPage);
	}, [currentPage]);
	useEffect(() => {
		if (reloadData) {
			refetch();
		}
		setReloadData(false);
	}, [reloadData]);
	useEffect(() => {
		return () => {
			SetSortFilter({ type: "", value: "" });
			setSearchQuery("");
		};
	}, [SetSortFilter, setSearchQuery]);
	useEffect(() => {
		if (deleteItem.condition === true && deleteItem.value === "permission") {
			refetch();
			if (PermissionsData?.data.length === 1 && currentPage > 1) {
				setCurrentPage(currentPage - 1);
				localStorage.setItem("page", currentPage);
			}
			setDeleteItem({ condition: null, value: null });
		}
	}, [
		currentPage,
		deleteItem.condition,
		deleteItem.value,
		refetch,
		setDeleteItem,
		PermissionsData?.data,
	]);
	const handleTableChange = (pagination, filters, sorter) => {
		if (sorter.order) {
			setSort({
				by: sorter.field,
				order: sorter.order === "ascend" ? "asc" : "desc",
			});
		} else {
			setSort({
				by: "",
				order: "",
			});
		}
	};
	useEffect(() => {
		setCurrentPage(1);
	}, [searchQuery]);
	const viewType = (type) => {
		if (type === "VIEW") {
			return "blue";
		} else if (type === "ADD") {
			return "green";
		} else if (type === "EDIT") {
			return "orange";
		} else if (type === "DELETE") {
			return "red";
		}
	};

	const modulesColor = (modules) => {
		if (modules === "QAQC") {
			return "orange";
		} else if (modules === "FLEET_MANAGEMENT") {
			return "blue";
		} else if (modules === "FIELD_STAFF") {
			return "green";
		} else if (modules === "SAFETY") {
			return "purple";
		}
	};
	const modulesType = (modules) => {
		if (modules === "QAQC") {
			return "QA_QC";
		} else if (modules === "FLEET_MANAGEMENT") {
			return "FLEET MANAGEMENT";
		} else if (modules === "FIELD_STAFF") {
			return "FIELD STAFF";
		} else if (modules === "SAFETY") {
			return "SAFETY";
		}
	};
	const userTypeColor = (modules) => {
		if (modules === "SUPERVISOR") {
			return "orange";
		} else if (modules === "CUSTOMER") {
			return "blue";
		} else if (modules === "FIELD_STAFF") {
			return "green";
		}
	};
	const permissionsColumns = [
		{
			title: trans("Name"),
			dataIndex: "name",
			sorter: true,
			fixed: "left", // ✅ fix to the left
			key: "name",
			width: 150, // ✅ must give width when fixed
			render: (name) => <span>{name}</span>,
		},
		{
			title: trans("Description"),
			dataIndex: "description",
			key: "description",
			width: 250,
			render: (description) => <span>{description || "- - - - -"}</span>,
		},
		{
			title: trans("User Type"),
			sorter: true,
			dataIndex: "userType",
			key: "userType",
			width: 150,
			render: (userType) => (
				<Tag color={userTypeColor(userType)} className="text-capitalize">
					{trans(userType?.replace(/_/g, " "))}
				</Tag>
			),
		},
		{
			title: trans("Resource"),
			sorter: true,
			dataIndex: "resources",
			key: "resources",
			width: 150,
			render: (resources) => <span>{trans(resources.toLowerCase())}</span>,
		},
		{
			title: trans("Modules"),
			sorter: true,
			dataIndex: "modules",
			key: "modules",
			width: 150,
			render: (modules) => (
				<Tag color={modulesColor(modules)}>{trans(modulesType(modules))}</Tag>
			),
		},
		{
			title: trans("Sub-Modules"),
			dataIndex: "submodules",
			key: "submodules",
			width: 180,
			render: (submodules) => (
				<span>
					{submodules?.map((item) => trans(item.toLowerCase())).join(", ")}
				</span>
			),
		},
		{
			title: trans("Access Type"),
			sorter: true,
			dataIndex: "actions",
			key: "actions",
			width: 150,
			render: (actions) => (
				<Tag color={viewType(actions)}>
					{trans(
						actions.charAt(0).toUpperCase() + actions.slice(1).toLowerCase()
					)}
				</Tag>
			),
		},

		{
			title: trans("Created By"),
			dataIndex: "createdBy",
			key: "createdBy",
			width: 180,
			render: (createdBy) => <span>{createdBy?.name}</span>,
		},
		{
			title: trans("Created At"),
			sorter: true,
			dataIndex: "createdAt",
			key: "createdAt",
			width: 200,
			render: (createdAt) => <span>{formatDateString(createdAt)}</span>,
		},
		{
			title: trans("Actions"),
			key: "actions",
			fixed: "right", // ✅ fix to the right
			width: 120, // ✅ must give width when fixed
			render: (_, record) => (
				<Actions
					permissionId={record.id}
					name={record.name}
					type="permissions"
					canAddTask={create}
					canEdit={edit}
					canDelete={canDelete}
				/>
			),
		},
	];

	return (
		<div className="users">
			<Helmet>
				<title>Permissions</title>
				<meta name="description" content="Users" />
			</Helmet>
			<PermissionsHead
				setFilter={setFilter}
				setCurrentPage={setCurrentPage}
				filter={filter}
			/>
			<div className="bg-white-rounded-top table-parent">
				<AntdTable
					columns={permissionsColumns}
					dataSource={PermissionsData?.data || []}
					loading={false}
					pageSize={limit}
					totalItems={PermissionsData?.totalResults || 0} // Total count for pagination
					currentPage={currentPage}
					onPageChange={(page) => setCurrentPage(page)}
					onLimitChange={(newLimit) => {
						setLimit(newLimit);
						setCurrentPage(1);
					}}
					onTableChange={handleTableChange}
				/>
			</div>
			<PermissionsForm />
		</div>
	);
}
